/*function initSnowflakeAnimations() {
  const wrappers = document.querySelectorAll('.xmas-snowflakes');
  if (!wrappers.length) return;

  if (!('IntersectionObserver' in window)) {
    wrappers.forEach(wrapper => playSnowflakeSequence(wrapper));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      playSnowflakeSequence(entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.1
  });

  wrappers.forEach(wrapper => observer.observe(wrapper));
}

function playSnowflakeSequence(wrapper) {
  const rights  = wrapper.querySelectorAll('.snowflake-right');
  const lefts   = wrapper.querySelectorAll('.snowflake-left');
  const bottoms = wrapper.querySelectorAll('.snowflake-bottom');

  const sequence = [
    ...rights,
    ...lefts,
    ...bottoms
  ].filter(Boolean);

  sequence.forEach((el, i) => {
    setTimeout(() => {
      el.classList.add('snow-appear');
    }, i * 1200); 
  });
}

document.addEventListener('DOMContentLoaded', initSnowflakeAnimations);
*/

/* ============================================================
   Neovitale Easter Egg - Rolling Egg + Popup
   ============================================================ */

function buildEasterPopup() {
  if (document.getElementById('neo-easter-popup')) return;

  var overlay = document.createElement('div');
  overlay.id = 'neo-easter-overlay';

  var popup = document.createElement('div');
  popup.id = 'neo-easter-popup';
  popup.setAttribute('role', 'dialog');
  popup.setAttribute('aria-modal', 'true');
  popup.setAttribute('aria-label', 'Easter surprise');

  popup.innerHTML = [
    '<button id="neo-easter-close" class="neo-egg-close" type="button" aria-label="Close">&times;</button>',

    '<h2 class="neo-egg-heading">Happy Easter</h2>',

    '<div class="neo-egg-deco" aria-hidden="true">',
    '  <img id="neo-egg-deco-img" src="" alt="" width="80" height="104">',
    '</div>',

    '<div class="neo-egg-body">',
    '  <p class="neo-egg-tagline">You caught a rolling egg!</p>',
    '  <p class="neo-egg-message">Use this exclusive code at checkout for a special Easter discount:</p>',
    '  <div class="neo-egg-code-wrap">',
    '    <span id="neo-egg-code" class="neo-egg-code" role="textbox" aria-readonly="true" tabindex="0">NEOEASTER</span>',
    '    <button id="neo-egg-copy" class="neo-egg-copy-btn" type="button" aria-label="Copy discount code">Copy</button>',
    '  </div>',
    '</div>',

    '<p class="neo-egg-footer">Enjoy your purchase!</p>'
  ].join('');

  overlay.appendChild(popup);
  document.body.appendChild(overlay);

  // Copy to clipboard
  document.getElementById('neo-egg-copy').addEventListener('click', function () {
    var code = document.getElementById('neo-egg-code').textContent.trim();

    navigator.clipboard.writeText(code).then(function () {
      showCopied();
    });
  });

  // Close button
  document.getElementById('neo-easter-close').addEventListener('click', closeEasterPopup);

  // Click outside overlay to close
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeEasterPopup();
  });

  // Esc key to close
  document.addEventListener('keydown', function onEsc(e) {
    if (e.key === 'Escape') {
      closeEasterPopup();
      document.removeEventListener('keydown', onEsc);
    }
  });
}

function showCopied() {
  var btn = document.getElementById('neo-egg-copy');
  btn.textContent = 'Copied!';
  btn.classList.add('is-copied');
  setTimeout(function () {
    btn.textContent = 'Copy';
    btn.classList.remove('is-copied');
  }, 2000);
}

function openEasterPopup(btn) {
  var overlay = document.getElementById('neo-easter-overlay');
  if (!overlay) return;

  // Set the decorative egg image from the clicked button
  var decoImg = document.getElementById('neo-egg-deco-img');
  if (decoImg && btn) {
    var src = btn.querySelector('img') ? btn.querySelector('img').src : '';
    decoImg.src = src;
  }

  overlay.classList.add('is-open');
  document.body.classList.add('neo-egg-noscroll');
  
  // Store all egg sections for resume
  overlay._eggOuters = Array.prototype.slice.call(document.querySelectorAll('.neovitale-egg-outer'));
}

function closeEasterPopup() {
  var overlay = document.getElementById('neo-easter-overlay');
  if (!overlay) return;
  overlay.classList.remove('is-open');
  document.body.classList.remove('neo-egg-noscroll');

  // Resume all egg sections
  if (overlay._eggOuters) {
    overlay._eggOuters.forEach(function(outer) {
      if (outer._eggResume) outer._eggResume();
    });
    overlay._eggOuters = null;
  }
}

function stopAllEggs() {
  var allOuters = document.querySelectorAll('.neovitale-egg-outer');
  allOuters.forEach(function(outer) {
    if (outer._eggCleanup) outer._eggCleanup();
    // Hide the egg container
    outer.style.display = 'none';
  });
}

/* Run each egg as a fully independent rAF particle.
   Eggs are evenly spaced behind the left edge so one enters every ~25% of the journey.
   Y positions are kept at least 15% apart so eggs never stack on the same lane. */
function runEggParade(outer) {
  var allMovers = Array.prototype.slice.call(outer.querySelectorAll('.neovitale-egg-mover'));
  
  // Detect device performance and adjust egg count accordingly
  var isMobile = window.innerWidth < 768;
  var deviceMemory = navigator.deviceMemory || 4; // GB, defaults to 4 if not available
  var hardwareConcurrency = navigator.hardwareConcurrency || 4; // CPU cores
  
  // Very low-end device: use only 3 eggs
  // Low-end device: use 4 eggs  
  // Normal mobile: use 4 eggs
  // Desktop: use all 8 eggs
  var eggCount;
  if (!isMobile) {
    eggCount = allMovers.length; // Desktop: all eggs
  } else if (deviceMemory <= 2 || hardwareConcurrency <= 2) {
    eggCount = 3; // Very low-end mobile
  } else {
    eggCount = 4; // Normal mobile
  }
  
  var movers = allMovers.slice(0, eggCount);
  
  // Hide unused eggs
  allMovers.forEach(function(mover, i) {
    if (i >= movers.length) {
      mover.style.display = 'none';
    } else {
      mover.style.display = '';
    }
  });
  
  var paused = false;
  var rafId  = null;
  var EGG_W  = 50;   // px - off-screen buffer
  var SPEED  = isMobile ? 90 : 138;  // px per second (not per frame)
  // Rolling spin: degrees per second
  var SPIN   = (SPEED / (2 * Math.PI * 20)) * 360 * 0.55;
  var MIN_Y_GAP = 15; // % - minimum vertical distance between any two eggs
  
  var lastTime = performance.now();

  function rnd(min, max) { return min + Math.random() * (max - min); }

  // Pick a y% that is at least MIN_Y_GAP away from all occupied y values
  function pickY(occupiedYs) {
    var attempts = 0, y;
    do {
      y = rnd(5, 88);
      var ok = occupiedYs.every(function (ey) { return Math.abs(ey - y) >= MIN_Y_GAP; });
      if (ok || attempts >= 20) break;
      attempts++;
    } while (true);
    return y;
  }

  var containerW = outer.offsetWidth || window.innerWidth;
  
  // Calculate spacing to fill entire width: when first egg exits right, last egg enters left
  var totalJourney = containerW + (2 * EGG_W);  // Full distance from off-left to off-right
  var baseSpacing = totalJourney / movers.length; // Divide journey by number of eggs
  var VARIATION = 15;                            // ±15px random variation for natural feel

  var usedYs = [];
  var eggs = movers.map(function (mover, i) {
    var btn = mover.querySelector('.neovitale-egg-btn');
    
    // Enable GPU acceleration
    mover.style.willChange = 'transform';
    btn.style.willChange = 'transform';
    
    // Start ALL eggs off-screen to the left, spaced out so they roll in one by one
    // Each egg starts progressively further back
    var startX = -EGG_W - (i * baseSpacing) + rnd(-VARIATION, VARIATION);
    
    var rot = rnd(0, 360);
    var y   = pickY(usedYs);
    usedYs.push(y);
    mover.style.top = y + '%';
    // Apply transforms with translate3d for GPU acceleration
    mover.style.transform = 'translate3d(' + startX.toFixed(1) + 'px, 0, 0)';
    btn.style.transform   = 'translate3d(0, 0, 0) rotate(' + rot.toFixed(1) + 'deg)';
    return {
      mover: mover,
      btn:   btn,
      state: { x: startX, y: y, rotation: rot }
    };
  });

  function tick() {
    if (paused) return;
    
    // Calculate delta time (time since last frame) for smooth animation on any device
    var now = performance.now();
    var deltaTime = (now - lastTime) / 1000; // Convert to seconds
    lastTime = now;
    
    // Cap delta time to prevent huge jumps if tab was inactive
    if (deltaTime > 0.1) deltaTime = 0.1;
    
    containerW = outer.offsetWidth || containerW;
    
    // Recalculate spacing if container width changes (responsive)
    var totalJourney = containerW + (2 * EGG_W);
    baseSpacing = totalJourney / eggs.length;

    eggs.forEach(function (egg, idx) {
      var s = egg.state;
      // Time-based movement: consistent speed on any frame rate
      s.x        += SPEED * deltaTime;
      s.rotation += SPIN * deltaTime;

      // Use translate3d for GPU acceleration (better performance on mobile)
      egg.mover.style.transform = 'translate3d(' + s.x.toFixed(1) + 'px, 0, 0)';
      egg.btn.style.transform   = 'translate3d(0, 0, 0) rotate(' + s.rotation.toFixed(1) + 'deg)';

      // Exited right edge — respawn behind leftmost egg to maintain continuous parade
      if (s.x > containerW + EGG_W) {
        var otherYs = eggs.filter(function (_, i) { return i !== idx; }).map(function (e) { return e.state.y; });
        var newY = pickY(otherYs);
        
        // Find leftmost egg and place this one behind it with base spacing
        var leftMostX = Math.min.apply(null, eggs.map(function(e) { return e.state.x; }));
        s.x = leftMostX - baseSpacing - rnd(-VARIATION, VARIATION);
        s.y = newY;
        s.rotation = rnd(0, 360);
        egg.mover.style.top = newY + '%';
      }
    });

    rafId = requestAnimationFrame(tick);
  }

  lastTime = performance.now(); // Initialize before starting animation
  rafId = requestAnimationFrame(tick);

  // Store cleanup function
  outer._eggCleanup = function() {
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    if (outer._resizeHandler) {
      window.removeEventListener('resize', outer._resizeHandler);
      outer._resizeHandler = null;
    }
    // Remove will-change to free GPU resources
    eggs.forEach(function(egg) {
      egg.mover.style.willChange = 'auto';
      egg.btn.style.willChange = 'auto';
    });
  };

  outer._eggPause  = function () {
    paused = true;
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
  };
  outer._eggResume = function () {
    if (paused) { 
      paused = false;
      lastTime = performance.now(); // Reset time to prevent huge delta
      rafId = requestAnimationFrame(tick);
    }
  };
  
  // Handle responsive: reinitialize if screen size crosses mobile threshold
  var lastIsMobile = isMobile;
  outer._resizeHandler = function() {
    var nowIsMobile = window.innerWidth < 768;
    if (nowIsMobile !== lastIsMobile) {
      lastIsMobile = nowIsMobile;
      outer._eggCleanup();
      runEggParade(outer); // Reinitialize with correct egg count
    }
  };
  window.addEventListener('resize', outer._resizeHandler);
}

function showHuntIntroPopup(onDismiss) {
  var overlay = document.createElement('div');
  overlay.id = 'neo-hunt-overlay';

  var popup = document.createElement('div');
  popup.id = 'neo-hunt-popup';
  popup.setAttribute('role', 'dialog');
  popup.setAttribute('aria-modal', 'true');
  popup.setAttribute('aria-label', 'Easter Hunt');

  // Grab egg image src from the first egg on the page
  var firstEggImg = document.querySelector('.neovitale-egg-btn img');
  var eggSrc = firstEggImg ? firstEggImg.src : '';

  popup.innerHTML = [
    '<div class="neo-hunt-deco" aria-hidden="true">',
    '  <img src="' + eggSrc + '" alt="" width="70" height="91">',
    '</div>',
    '<h2 class="neo-hunt-heading">Easter Hunt is Live!</h2>',
    '<p class="neo-hunt-message">Catch a rolling egg and unlock your exclusive discount!</p>',
    '<button id="neo-hunt-start" class="neo-hunt-btn" type="button">Start Hunting</button>'
  ].join('');

  overlay.appendChild(popup);
  document.body.appendChild(overlay);

  // Trigger open transition on next frame
  requestAnimationFrame(function () {
    overlay.classList.add('is-open');
    document.body.classList.add('neo-egg-noscroll');
  });

  function closeIntro() {
    overlay.classList.remove('is-open');
    document.body.classList.remove('neo-egg-noscroll');
    document.removeEventListener('keydown', onEsc);
    setTimeout(onDismiss, 300); // wait for fade-out then start eggs
  }

  document.getElementById('neo-hunt-start').addEventListener('click', closeIntro);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeIntro();
  });

  function onEsc(e) {
    if (e.key === 'Escape') closeIntro();
  }
  document.addEventListener('keydown', onEsc);
}

function startEggSections() {
  var outers = document.querySelectorAll('.neovitale-egg-outer');
  if (!outers.length) return;

  function startOuter(outer) {
    outer.classList.add('is-active'); // reveal only after hunt intro dismissed
    runEggParade(outer);
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        startOuter(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    outers.forEach(function (outer) { observer.observe(outer); });
  } else {
    outers.forEach(startOuter);
  }

  document.querySelectorAll('.neovitale-egg-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      
      // Pause ALL egg sections, not just the clicked one
      var allOuters = document.querySelectorAll('.neovitale-egg-outer');
      allOuters.forEach(function(outer) {
        if (outer._eggPause) outer._eggPause();
      });
      
      openEasterPopup(btn);
    });
  });
}

function initEasterEgg() {
  buildEasterPopup();

  var outers = document.querySelectorAll('.neovitale-egg-outer');
  if (!outers.length) return;

  // Show hunt intro first; eggs only start after user dismisses it
  showHuntIntroPopup(startEggSections);
}

document.addEventListener('DOMContentLoaded', initEasterEgg);
